import React from 'react'
import styled from 'styled-components'
import { ModalColorTheme } from 'theme/modal/colors'
import AlchemyModal, { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import Box from 'UIKit/Box/Box'
import Security2FA from './2FA'

const SettingSecurityModal: React.FC<ModalProps> = ({ onDismiss }) => {
  return (
    <StyledModal id="popup-signwallet" onDismiss={onDismiss} colorTheme={ModalColorTheme.Darkblue}>
      <ModalHeader colorTheme={ModalColorTheme.Darkblue} title="Security" />
      <ModalBody mt="20px">
        <Box
          style={{
            background: 'rgba(35, 44, 61, 0.20)',
            borderRadius: '12px',
          }}
          p="20px"
        >
          <Security2FA />
        </Box>
      </ModalBody>
    </StyledModal>
  )
}

const StyledModal = styled(AlchemyModal)`
  ${({ theme }) => theme.mediaQueries.sm} {
    min-width: 440px !important;
    max-width: 440px !important;
  }
`

export default SettingSecurityModal
